"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionFooter = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useQuestionnaireNavigation = require("../../hooks/questionnaire/useQuestionnaireNavigation");
var _services = require("../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var QuestionFooter = function QuestionFooter() {
  var _useQuestionnaireNavi = (0, _useQuestionnaireNavigation.useQuestionnaireNavigation)(),
    onNext = _useQuestionnaireNavi.onNext,
    onBack = _useQuestionnaireNavi.onBack,
    isBackVisible = _useQuestionnaireNavi.isBackVisible,
    isNextEnabled = _useQuestionnaireNavi.isNextEnabled;
  var nextButtonAppearance = isNextEnabled ? 'primary' : 'secondary';
  var nextButtonState = isNextEnabled ? '' : 'disabled';
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: 'center'
  }, isBackVisible ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: 'between'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 6
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-back",
    text: _services.locale.localeString('Questionnaire.ButtonBack'),
    width: 'full',
    appearance: "alt1",
    onClick: onBack
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 6
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-next",
    width: 'full',
    text: _services.locale.localeString('Questionnaire.ButtonNext'),
    appearance: nextButtonAppearance,
    state: nextButtonState,
    onClick: onNext
  }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-next",
    width: 'full',
    text: _services.locale.localeString('Questionnaire.ButtonNext'),
    appearance: nextButtonAppearance,
    state: nextButtonState,
    onClick: onNext
  }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-back",
    text: _services.locale.localeString('Questionnaire.ButtonBack'),
    width: 'full',
    appearance: "alt1",
    onClick: onBack
  }))))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-next",
    width: 'full',
    text: _services.locale.localeString('Questionnaire.ButtonNext'),
    appearance: nextButtonAppearance,
    state: nextButtonState,
    onClick: onNext
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 8
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-next",
    width: 'full',
    text: _services.locale.localeString('Questionnaire.ButtonNext'),
    appearance: nextButtonAppearance,
    state: nextButtonState,
    onClick: onNext
  }))))));
};
exports.QuestionFooter = QuestionFooter;